import * as React from "react";

import TimelapseOutlinedIcon from "@mui/icons-material/TimelapseOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import NotInterestedOutlinedIcon from "@mui/icons-material/NotInterestedOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import PauseOutlinedIcon from "@mui/icons-material/PauseOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";

const iconStyle = { width: "20px", height: "20px" };
export const OrderStatusEnumIcons = [
  {
    id: "pending",
    name: "Pending",
    color: "primary",
    icon: <TimelapseOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "expired",
    name: "Expired",
    color: "warning",
    icon: <TimelapseOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "processing",
    name: "Processing",
    color: "primary",
    icon: <TimelapseOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "complete",
    name: "Complete",
    color: "success",
    icon: <CheckOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "delivered",
    name: "Delivered",
    color: "success",
    icon: <CheckOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "canceled",
    name: "Canceled",
    color: "error",
    icon: <CancelOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "closed",
    name: "Closed",
    color: "success",
    icon: <NotInterestedOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "backorder",
    name: "Backorder",
    color: "primary",
    icon: <ReplayOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "fraud",
    name: "Fraud",
    color: "error",
    icon: <ErrorOutlineOutlinedIcon sx={iconStyle} />,
  },
  { 
    id: "onhold", 
    name: "Onhold", 
    color: "warning",
    icon: <PauseOutlinedIcon sx={iconStyle} /> 
  },
  {
    id: "shipped",
    name: "Shipped",
    color: "primary",
    icon: <LocalShippingOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "reserve",
    name: "Reserve",
    color: "primary",
    icon: <FactCheckOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "na_reserve",
    name: "Na Reserve",
    color: "primary",
    icon: <FactCheckOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "pending_payment",
    name: "Pending Payment",
    color: "primary",
    icon: <TimelapseOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "request",
    name: "Request",
    color: "primary",
    icon: <RequestPageOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "requested_refund",
    name: "Requested refund",
    color: "warning",
    icon: <RequestPageOutlinedIcon sx={iconStyle} />,
  }
];
